<template>
  <SharedLink
    :link="link"
    class="hover:underline"
    :data-ab-id="dataAbId"
  >
    <div class="mx-lg mobile:mx-md">
      <div
        v-if="image"
        class="mx-auto flex size-[170px] items-center justify-center overflow-hidden rounded-full border-2 border-neutral-100 p-2 mobile:size-[130px]"
      >
        <NuxtImg
          :src="image"
          sizes="lg:100vw 48vw"
          :srcset="srcSet"
          :alt="alt"
          :loading="imageLoadType"
          :preload="imageLoadType === 'eager'"
          :fetchpriority="imageLoadType === 'eager' ? 'high' : 'low'"
        />
      </div>
      <div class="mt-md px-4 text-center font-bold">
        {{ title }}
      </div>
      <div class="mt-md px-4 text-center">
        {{ subtitle }}
      </div>
    </div>
  </SharedLink>
</template>

<script lang="ts" setup>
interface Props {
  srcSet?: any[];
  image?: string;
  title?: string;
  subtitle?: string;
  ctaLink?: any;
  slug?: string;
  dataAbId?: string;
  alt?: string;
}

const props = withDefaults(defineProps<Props>(), {
  srcSet: () => [],
  image: '',
  title: '',
  subtitle: '',
  ctaLink: undefined,
  slug: '',
  alt: '',
});

const link = computed(() => {
  if (props.slug) {
    return {
      url: `/c/${props.slug}`,
      type: 'page',
      ...props.ctaLink,
    };
  }
  return props.ctaLink;
});

const imageLoadType = inject<HTMLImageElement['loading']>('imageLoadType', 'lazy');
</script>
